module.exports = __webpack_public_path__ + "static/img/24-2.6b8e954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-2.jpg
// module id = w0tu
// module chunks = 0